const MuiCard = {
  root: {
    borderRadius: 5,
  },
};

export default MuiCard;
